export const DATASOURCEID_3D_STEREOSCOPIC_SENSOR = "0775255a-ceaa-488e-a6b0-0b2824a59c93"; /// SMS Store Traffic
// export const DATASOURCEID_PARKING = "2cf4c7b2-4d8f-4d8b-ab1c-e115d96ee5fe"; /// ADAMANT
export const DATASOURCEID_RF_SENSORS = "d4745f0a-6f7b-445a-b04a-a2ae66189837"; /// ARM
// export const DATASOURCEID_BUSES = "4ac0133a-25f1-4e09-99ab-676bca63650d"; /// IoTech
// export const DATASOURCEID_PMY_VISIONS = "6e2aa896-7683-4824-9ae2-aa362b4d5f4a"; /// Lotus Lab
// export const DATASOURCEID_RFID_PASSIVE = "ae504b7e-f315-41c6-8136-1fc206ce0e7b"; /// Stark RFID
